import {exists} from 'shared/utils/custom-utils';

export function clickFileSelect(multiple: boolean = true): Promise<File[]> {
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = multiple;
    input.click();

    return new Promise((resolve, reject) => {
        input.addEventListener('change', (event: InputEvent) => {
            const fileList = (event.target as HTMLInputElement)?.files;
            if (!exists(fileList)) {
                reject(new Error('File list is empty.'));
            }

            const files = Array.from(fileList);
            if (files.length === 0) {
                reject(new Error('File list is empty.'));
            }

            resolve(files);
        });
    });
}